import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Grid,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import TopNavBar from '../../Components/TopBar/Navbar';
import { VaultDetails } from './components/VaultDetails';
import { VaultSummary } from './components/VaultSummary';
import { VaultHeader } from './components/VaultHeader';
import { Tabs } from './components/Tabs';
import { TxStatus, useStakingContext } from './contexts/staking.context';
import CustomModal from '../../Components/Modal/CustomModal';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { MdOutlineErrorOutline } from 'react-icons/md';
import { REACT_APP_ETH_TRANSACTION } from '../../Config/Config';
import GradiantButton from '../../Components/Button/GradiantButton';
import { History } from './components/History';
import { Withdraw } from './components/Withdraw';
import { useAccount } from 'wagmi';
import { useWalletAgreement } from './useAgreements';

export const Vaults = () => {
  const { isConnected, address } = useAccount();
  const [openIndex, setOpenIndex] = React.useState(null);

  const [showModal, setShowModal] = React.useState(false);
  const { hasAccepted, acceptAgreement } = useWalletAgreement();

  useEffect(() => {
    if (isConnected && !hasAccepted) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [isConnected, address, hasAccepted]);

  const handleConfirmAgreement = () => {
    setShowModal(false);
    acceptAgreement();
  };

  const {
    vaults,
    txInProgress,
    setTxInProgress,
    txStatus,
    errorMessage,
    setTxStatus,
    txHash,
    setTxHash,
    selectedTab,
  } = useStakingContext();

  return (
    <Grid
      container
      gap="50px"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'start'}
      className="leaderboard_page"
    >
      <Grid container zIndex={100}>
        <TopNavBar />
      </Grid>

      <Grid container justifyContent="center">
        <Grid
          item
          xs={12}
          md={10}
          lg={10}
          flexDirection="column"
          display="flex"
          gap="42px"
        >
          <Grid
            item
            lg={8}
            md={10}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            className="mx-auto"
          >
            <p className="landingHeading text-center">Vaults</p>
          </Grid>
          <Grid
            item
            lg={8}
            md={10}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            className="mx-auto"
            mb="16px"
          >
            <Tabs />
          </Grid>
          <Grid
            display="flex"
            gap="16px"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="space-between"
            className="text-white"
          >
            {selectedTab === 'withdraw' && <Withdraw />}
            {selectedTab === 'history' && <History />}
            {selectedTab === 'vaults' && (
              <>
                <VaultHeader />
                <Grid
                  display="flex"
                  justifyContent="space-between"
                  flexDirection="column"
                  gap="40px"
                  width="100%"
                  mb="36px"
                >
                  {vaults.map((vault, index) => {
                    return (
                      <Accordion
                        key={index}
                        sx={{
                          width: '100%',
                          background: '#28282B',
                          backdropFilter: 'blur(2.4300003051757812px)',
                          border: '0.9px solid #5F4C3E',
                          borderRadius: '14.4px !important',
                          color: 'white',
                        }}
                        expanded={isConnected ? openIndex === index : false}
                        onChange={() =>
                          setOpenIndex(openIndex === index ? null : index)
                        }
                      >
                        <AccordionSummary
                          sx={{ py: 1 }}
                          expandIcon={
                            <ExpandMoreIcon sx={{ color: 'white' }} />
                          }
                          aria-controls="panel1-content"
                          id={`panel-${index}-header`}
                        >
                          <VaultSummary vault={vault} />
                        </AccordionSummary>

                        <AccordionDetails
                          sx={{ borderTop: '1px solid #777E90' }}
                        >
                          <VaultDetails vault={vault} />
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <CustomModal
        open={txInProgress}
        setOpen={setTxInProgress}
        closebtn={'remove'}
        modalTitle={<h5>Wallet Actions</h5>}
        width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              className="p-2 rounded"
              bgcolor={'rgba(0, 0, 0, 0.32)'}
            >
              {txStatus === TxStatus.LOADING && (
                <Grid className="d-flex">
                  <p> Transaction is loading</p>
                </Grid>
              )}

              {txStatus === TxStatus.WAITING ? (
                <span style={{ color: '#ffffff' }}>Waiting</span>
              ) : txStatus === TxStatus.LOADING ? (
                <span>
                  <CircularProgress style={{ color: '#FFF' }} size={20} />
                </span>
              ) : txStatus === TxStatus.COMPLETED ? (
                <p>
                  {' '}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              ) : (
                <p>
                  <MdOutlineErrorOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              )}
            </Grid>

            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className="mt-4 w-100 "
            >
              {txStatus === TxStatus.COMPLETED ? (
                <p
                  className="airdrop_paratext mb-3 p-3"
                  style={{
                    border: '1px solid #ffffff',
                    borderRadius: '25px',
                    textAlign: 'center',
                  }}
                >
                  Your transaction was finalized{' '}
                </p>
              ) : (
                (txStatus === TxStatus.ERROR ||
                  txStatus === TxStatus.FAILED_TO_INITIATE) && (
                  <p
                    className="airdrop_paratext mb-3 p-3"
                    style={{
                      border: '1px solid #ffffff',
                      borderRadius: '25px',
                      textAlign: 'center',
                    }}
                  >
                    {errorMessage ||
                      'Error: transaction was unsuccessful. Please try again.'}
                  </p>
                )
              )}{' '}
              {txHash !== '' ? (
                <>
                  <a
                    href={REACT_APP_ETH_TRANSACTION + txHash}
                    target="blank"
                    style={{
                      color: '#fff',
                      width: '70%',
                      marginBottom: '20px',
                    }}
                  >
                    <GradiantButton
                      btnTextColor="#FFF"
                      text={'CHECK ETHERSCAN'}
                      width="100%"
                      onClick={undefined}
                      style={undefined}
                      btnColor={undefined}
                      Icon={undefined}
                      disabled={undefined}
                      endIcon={undefined}
                      height={undefined}
                      isUpolad={undefined}
                      FileUpload={undefined}
                      Filetype={undefined}
                    />
                  </a>

                  <GradiantButton
                    btnTextColor="#FFF"
                    text={'CLOSE'}
                    width="70%"
                    onClick={() => {
                      {
                        setTxInProgress(false);
                        setTxHash('');
                        setTxStatus(TxStatus.WAITING);
                      }
                    }}
                    style={undefined}
                    btnColor={undefined}
                    Icon={undefined}
                    disabled={undefined}
                    endIcon={undefined}
                    height={undefined}
                    isUpolad={undefined}
                    FileUpload={undefined}
                    Filetype={undefined}
                  />
                </>
              ) : (
                <GradiantButton
                  btnTextColor="#FFF"
                  text={
                    txStatus !== TxStatus.COMPLETED
                      ? 'CLOSE'
                      : 'CHECK ETHERSCAN'
                  }
                  width="100%"
                  onClick={() => {
                    setTxInProgress(false);
                    setTxHash('');
                    setTxStatus(TxStatus.WAITING);
                  }}
                  style={undefined}
                  btnColor={undefined}
                  Icon={undefined}
                  disabled={undefined}
                  endIcon={undefined}
                  height={undefined}
                  isUpolad={undefined}
                  FileUpload={undefined}
                  Filetype={undefined}
                />
              )}
            </Grid>
          </Grid>
        }
        transparent={undefined}
        height={undefined}
        scrollable={undefined}
      />

      {!hasAccepted && showModal && isConnected && (
        <CustomModal
          open={showModal}
          setOpen={() => setShowModal(false)}
          modalTitle={''}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          scrollable={false}
          closebtn={'remove'}
          height="auto"
          transparent={false}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                item
                lg={12}
                md={12}
                display="flex"
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                gap={'20px'}
              >
                <p style={{ textAlign: 'center', fontSize: '17px' }}>
                  By proceeding you have read, agree to and accept the <br />
                  <a
                    href="/pdf/OpenZK.-.Token.T.Cs.250526.pdf"
                    target="_blank"
                    className="landingPtag2"
                    style={{ fontSize: '14px' }}
                  >
                    Terms and Conditions of Holding and Usage of OZK Tokens
                  </a>
                  <br />
                  and{' '}
                  <a
                    href="/pdf/OpenZK_Terms.of.Use_250620.pdf"
                    target="_blank"
                    className="landingPtag2"
                    style={{ fontSize: '14px' }}
                  >
                    Terms of Use
                  </a>
                </p>
                <button
                  onClick={handleConfirmAgreement}
                  className="fakeConnectButton"
                >
                  Agree and Accept
                </button>
              </Grid>
            </Grid>
          }
        />
      )}
    </Grid>
  );
};
